<div class="modal-footer justify-content-between clearfix" style="display: block;">
  <button *ngIf="showCancel"
    type="button"
    class="btn btn-outline-secondary float-left"
    [disabled]="cancelDisabled"
    (click)="onCancelClick.emit()"
  >
    {{ cancelLabel }}
  </button>
  <button type="button" *ngIf="showCustomButton" class="btn btn-gold float-right" [disabled]="customButtonDisabled" (click)="onCustomButtonClick.emit()">
    {{ customButtonLabel }}
  </button>
    <button type="submit" class="btn btn-blue-prodiis float-right" [disabled]="saveDisabled">
    {{ saveLabel }}
  </button>
</div>
